export default {
  // Page titles
  pageTitle: '云端游戏活动管理',
  myActivities: '我的游戏活动',
  searchPlaceholder: '搜索游戏活动',
  addNew: '新增 云端小桌游',
  noActivities: '目前没有游戏活动',

  // Action menu
  settings: '设定',
  duplicate: '复制',
  copySuffix: '(复制)',
  deleteAction: '删除',

  // Modal titles
  createActivity: '添加游戏活动',
  updateActivity: '游戏活动设定',

  // Form fields
  activityName: '活动名称',
  activityNamePlaceholder: '新游戏活动',
  questionType: '题目类型',
  gameSettingsEntry: '游戏详细内容设定',
  enableEntry: '开放进入活动',
  disableEntryToEditSettings: '若要修改游戏设定，请先关闭「开放进入活动」',
  settingsLockedWarning: '活动已发布且开放进入，无法修改游戏设定',

  // Question types
  recognition: '辨识题',
  trueFalse: '是非题',
  multiChoice: '单选题',
  aiGenerated: '自定义',

  // Buttons
  cancel: '取消',
  confirm: '确定',
  publish: '发布短网址',
  gamePreview: '游戏预览',
  tryNow: '马上试玩',
  sendLink: '发送链接',
  sendLinkSuccess: '链接已发送',
  sendLinkFailed: '发送链接失败',

  // Messages
  activityCreated: '活动创建成功',
  activityDeleted: '活动删除成功',
  gameSettingsComingSoon: '游戏详细内容设置功能开发中',
  pushConfirmMessage: '推送后将以设定数据在云端新增一个小桌游活动，\n可用管理界面来查看。请确认是否推送小桌游？',

  // Error messages
  activityNameRequired: '活动名称为必填栏位',
  activityNameTooLong: '活动名称不可超过 20 个字元',

  // Game selection modal
  selectGameType: '选择游戏类型',

  // Game card names
  moleGameCard: '打地鼠',
  starGameCard: '摘星星',
  rocketGameCard: '火箭升空',
  snakeGameCard: '贪食蛇',
  mazeGameCard: '闖迷宮',
  aiGameCard: '自制游戏',

  // Game settings panel
  playerCount: '游戏人数',
  person: '人',
  defaultTemplate: '默认游戏模板',
  moleGame: '打地鼠',
  starGame: '摘星星',
  snakeGame: '贪食蛇',
  mazeGame: '闖迷宮',
  rocketGame: '火箭升空',
  aiGame: '自制游戏',
  allowTemplateChange: '允许变换游戏模板',
  switchGame: '切换游戏',
  gameParameters: '游戏参数设定',
  gameParametersNote: '游戏参数将在选择模板后进行设定',

  // Game parameters form
  topic: '主题',
  topicWithActivityName: '主题(即游戏活动名称)',
  inputTopic: '请输入主题',
  correctItems: '答对题目',
  correctItemsPlaceholder: '输入正答词汇，可用换行或逗号(,)分隔，按下Enter添加项目',
  errorItems: '答错题目',
  errorItemsPlaceholder: '输入错误词汇，可用换行或逗号(,)分隔，按下Enter添加项目',
  gameDuration: '游戏时长',
  second: '秒',
  moleSpeed: '地鼠速度',
  gameSpeed: '游戏速度',
  speedSlow: '慢速',
  speedMedium: '中速',
  speedFast: '快速',
  speedVeryFast: '超快',
  backgroundSetting: '背景设定',
  forest: '森林',
  desert: '沙漠',
  ocean: '海洋',

  // Validation messages
  wordExists: '此项目已存在',
  maxVocabulary: '正确项目最多 20 个',
  maxErrorVocabulary: '错误项目最多 20 个',
  unsubmittedWarning: '发现输入框中有未按下Enter的词汇，请确认后再进行操作!',

  // AI Custom Game
  customGameCode: '自制游戏代码',
  customGameCodePlaceholder: '请输入 HTML/CSS/JavaScript。这里 HTML 标记可输入简单版本或 style 和 script 标签的完整版本。',

  // Delete confirmation
  deleteConfirmTitle: '删除活动',
  deleteConfirmMessage: '确定要删除此活动吗？删除后将无法复原。',
  delete: '删除',
  deleting: '删除中...',

  // Preview mode
  previewMode: '预览模式',
  previewRefreshWarning: '提示：重新整理页面后，预览数据将被清除，并进入默认展示模式。如需预览，请从设置再次开启。',

  // Status indicators
  statusOpen: '已开放',
  emptyState: '准备中',

  // Short URL related messages
  shortUrlCopied: '短网址已复制到剪贴板',
  copyFailed: '复制失败，请手动复制',
  shortUrlAutoUpdated: '短网址已自动更新，请重新分享给学生',
  shortUrlGenerated: '短网址已生成，请按确定储存活动',
  shortUrlPublished: '短网址发布成功',
  shortUrlPublishFailed: '发布短网址失败，请稍后再试',
  qrcodeTitle: '扫描 QR Code',
  qrcodeGenerateFailed: '生成 QR Code 失败',

  // Activity operation messages
  activityCreateFailed: '创建活动失败，请稍后再试',
  activityUpdateFailed: '更新活动失败，请稍后再试',
  activityUpdated: '活动更新成功',
  activityDeleteFailed: '删除活动失败，请稍后再试',
  activityDuplicated: '活动复制成功',
  activityDuplicateFailed: '复制活动失败，请稍后再试',

  // Student info
  enterStudentInfo: '请输入学生信息',
  selectStudent: '请选择学生',
  studentName: '姓名',
  studentNamePlaceholder: '请输入姓名',
  studentSeatNumber: '座号（选填）',
  seatNumberPlaceholder: '例如：5',
  studentNameRequired: '请输入姓名',
  seatNumberRequired: '请输入座号',
  studentNameTooLong: '姓名不可超过 20 字元',
  seatNumberInvalid: '座号必须为 1-3 位数字',
  nameAlreadyUsed: '此姓名已被另一方玩家使用',
  seatNumberAlreadyUsed: '此座号已被另一方玩家使用',
  confirmStudentInfo: '开始游戏',

  // HT 名单匯入功能
  useHiTeachRoster: '使用 HT 导入名单',
  requestCurrentRoster: '重新请求当前名单',
  studentList: '学生名单',
  students: '位学生',
  seatNo: '座号',
  rosterEmptyHint: '当前没有名单数据，请点击「重新请求当前名单」从 HiTeach 获取',
  rosterNotFound: '未找到 HiTeach 名单，请确认是否从 HiTeach 打开',
  rosterLoadError: '加载名单时发生错误',
  rosterSourceOnlyInHT: '仅在 HT 内可设置名单来源',
  confirmRefreshRoster: '确定要重新从 HiTeach 请求当前名单吗？',
  requestingRoster: '正在请求名单...',
  refreshRosterError: '请求名单失败，请稍后再试',
  refreshRosterTimeout: '请求名单超时，请稍后再试',
  rosterRefreshSuccess: '名单已更新 ({count} 位学生)',
  rosterStillEmpty: '名单仍为空，请确认 HiTeach 是否有设置学生名单',
  clickToRefresh: '点击重新请求',

  // Activity loading
  activityLoadSuccess: '活动载入成功',
  loadActivitySuccess: '活动载入成功',
  activityNotOpen: '此活动尚未开放进入',
  activityLoadFailed: '载入活动失败',
  loadActivityFailed: '载入活动失败，将使用展示模式',

  // Score submission
  scoreSubmitted: '成绩提交成功',
  scoreSubmitFailed: '成绩提交失败，请稍后再试',

  // Scores panel
  viewScores: '成绩排行榜',
  scoresTitle: '成绩排行榜',
  loadingScores: '载入成绩中...',
  noScoresYet: '目前尚无成绩数据',
  totalSubmissions: '提交人数',
  averageScore: '平均分数',
  highestScore: '最高分',
  rank: '排名',
  seatNumber: '座号',
  score: '分数',
  correctCount: '答对',
  wrongCount: '答错',
  submitTime: '提交时间',
  prevPage: '上一页',
  nextPage: '下一页',
  loadScoresFailed: '载入成绩失败，请稍后再试',

  // HT 专属功能（webview + HT 名单）
  awesome: '点赞',
  sendScores: '派送成绩',
  clickToAwesome: '点击点赞',
  noSeatNumber: '此学生无座号',
  awesomeSent: '点赞已发送',
  awesomeFailed: '发送点赞失败',
  noScoresToSend: '目前没有可发送的成绩',
  noValidScores: '没有有效的成绩（需有座号）',
  scoresSent: '成绩已发送',
  sendScoresFailed: '发送成绩失败',

  // Game template switching messages
  templateSwitchedNoScore: '侦测到变换模板，为维持公平，将不会提交成绩！',

  // User guide messages - Step 1, 2, 3 & 4
  gameActGuide: {
    step1: {
      main: '从这里开始',
      sub: '创建你的第一个游戏活动'
    },
    step2: {
      hint1: 'Step 1: 填写游戏设定（题目、答案、游戏模板等）',
      hint2: 'Step 2: 点击「游戏预览」确认没问题',
      hint3: 'Step 3: 完成后点击左上角「返回」按钮',
      backButton: '完成后点这里返回'
    },
    step3: {
      confirmButton: '点击「确定」创建活动'
    },
    step4: {
      publishButton: '点击「发布短网址」分享给学生'
    }
  },

  // Security check messages
  securityCheck: {
    title: '⚠️ 程序代码安全检查发现以下问题',
    errorTitle: '🔴 严重问题',
    warningTitle: '⚠️ 警告',
    suggestionTitle: '建议',
    suggestion1: '避免使用 onclick, onerror 等 HTML 属性',
    suggestion2: '改用 addEventListener 方式绑定事件',
    suggestion3: '避免使用嵌套 iframe, object, embed 标签',
    continuePreview: '预览仍会继续,但建议修正这些问题以符合最佳实践。'
  },

  // Roster uncheck confirmation (non-WebView)
  rosterUncheckConfirmTitle: '取消使用 HT 导入名单',
  rosterUncheckConfirmMessage: '取消勾选并确定储存后，将会清空此活动中已载入的 HT 名单；之后仅能在 HiTeach 内重新取得名单。',

  // Clear settings
  clearSettings: '清空设定',
  confirmClearSettings: '确定要清空所有设定吗？',
  settingsCleared: '设定已清空',

  // Required field validation
  topicRequired: '请填写主题',
  correctItemsRequired: '请至少新增一个答对题目',
  errorItemsRequired: '请至少新增一个答错题目',
  questionListRequired: '请至少新增一个题目',
  requiredFieldsMissing: '以下栏位为必填：',

  // Activity usage display
  activityUsage: '游戏活动用量',
  usageFormat: '{current} / {max}',

  // Activity limit exceeded
  activityLimitExceeded: '已达活动数量上限（{maxLimit} 个），请删除部分活动后再试！'
};
